import React from 'react';

import Rating from "./Rating.js";

class Ratings extends React.Component {

    click = (name, value) => {
        name = name.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
            if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
        this.props.handleUpdate({
            target: {
                name,
                value
            }
        })
    };

    render() {
        return (
            <div>
                <div className="head">
                    <h2>Ratings</h2>
                    <p>Please score the following categories out of 5. With 1 being the lowest, and 5 being the highest.</p>
                </div>
                <div className="form">
                    <Rating
                        name={"Remuneration"}
                        description={"How does your rate of pay compare to your industry standard?"}
                        selected={this.props.remuneration}
                        click={this.click}
                    />
                    <Rating
                        name={"Benefits"}
                        description={"eg. Bonuses, shares, car parking, pension, health care, etc."}
                        selected={this.props.benefits}
                        click={this.click}
                    />
                    <Rating
                        name={"Career Progression"}
                        description={"Potential for promotion and career advancement."}
                        selected={this.props.careerProgression}
                        click={this.click}
                    />
                    <Rating
                        name={"Working Environment"}
                        description={"Do you feel valued, respected and part of a team?"}
                        selected={this.props.workingEnvironment}
                        click={this.click}
                    />
                    <Rating
                        name={"Work Life Balance"}
                        description={"Working hours, holidays and general well being in your workplace."}
                        selected={this.props.workLifeBalance}
                        click={this.click}
                    />
                    <Rating
                        name={"Training"}
                        description={"Does your company offer training or assistance with training / professional education?"}
                        selected={this.props.training}
                        click={this.click}
                    />
                    <Rating
                        name={"Family Friendly"}
                        description={"Does your work support and help family life?"}
                        selected={this.props.familyFriendly}
                        click={this.click}
                    />
                    <Rating
                        name={"Mental Health"}
                        description={"Do you feel your mental health is considered and supported within the workplace?"}
                        selected={this.props.mentalHealth}
                        click={this.click}
                    />
                    <Rating
                        name={"Social Environment"}
                        description={"Does your company have social events and company activities?"}
                        selected={this.props.socialEnvironment}
                        click={this.click}
                    />
                </div>
                <div className="head">
                    <h2>Your Team</h2>
                    <p>Tell us about your work place.</p>
                </div>
                <div className="form">
                    <textarea name="recommendation" placeholder="Your Review" onChange={this.props.handleUpdate} rows={5} maxLength={400}>{this.props.recommendation}</textarea>
                    <textarea name="teamLeader" placeholder="Best Manager or Team leader (Optional)" onChange={this.props.handleUpdate} rows={1} maxLength={400}>{this.props.teamLeader}</textarea>
                </div>
            </div>
        )
    }
}

export default Ratings;